import { StationAvatar } from '@app/components/base/stations/StationAvatar';
import { MinimumStation, Station } from '@mi-front/core';
import { Box, Typography } from '@mui/material';

interface Props {
  station: Station | MinimumStation;
  noTypo?: boolean;
}

export const StationLabel = (props: Props) => {
  const { station, noTypo = true } = props;

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <StationAvatar stationId={station.id} size={24} />
      {!noTypo && (
        <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
          {station.name}
        </Typography>
      )}
      {noTypo && station.name}
    </Box>
  );
};
